import ScrollToGameRvn from './ScrollToGameRvn';

export default ScrollToGameRvn;
